import axios from "axios";

const dataSourcesURL = "/api/v1/data_sources";

const dataSourcesApi = {
  fetch: (
    currentPage = 1,
    pageSize = 25,
    search = "",
    filterBy = "",
    filterValue = ""
  ) =>
    axios.get(dataSourcesURL, {
      params: {
        search: search,
        page: currentPage,
        per_page: pageSize,
        filter_by: filterBy,
        filter_value: filterValue,
      },
    }),
  get: id => axios.get(`${dataSourcesURL}/${id}`),
  create: payload => axios.post(dataSourcesURL, { data_source: payload }),
  edit: (id, payload) =>
    axios.put(`${dataSourcesURL}/${id}`, { data_source: payload }),
  delete: ids => {
    const params = new URLSearchParams(ids.map(id => ["ids[]", id]));
    return axios.delete(`${dataSourcesURL}/1?${params.toString()}`);
  },
  getTablesAndColumns: schema =>
    axios.get(`${dataSourcesURL}/get_tables_and_columns`, {
      params: { schema },
    }),
  fetchDataSourceSummary: payload =>
    axios.get(`${dataSourcesURL}/summary_graph?limit_from=${payload}`),
};

export default dataSourcesApi;
